<template>
	<span class="animated-logo" ref="animated-logo" />
</template>

<script>
import lottie from 'lottie-web'
import animationData from '@/assets/animation/animated-logo.json'

export default {
	name: 'AnimatedLogo',

	data() {
		return {
			animatedLogo: null
		}
	},

	mounted() {
		this.animatedLogo = lottie.loadAnimation({
			container: this.$refs['animated-logo'],
			renderer: 'svg',
			loop: true,
			autoplay: true,
			animationData
		})
	},

	beforeDestroy() {
		this.animatedLogo.destroy()
	}
}
</script>

<style lang="scss">
.animated-logo {
	display: block;
	width: 42px;
	height: 54px;
	margin: 0 auto 20px;

	svg {
		width: 100%;
		height: 100%;
	}
}
</style>
